import { Accordion } from '@skupreme/shared/ui';
import { AccordionBodyContainer, BoldText } from './styles';

const NOTES = [
  ['Customer', 'None'],
  ['To Buyer', 'None'],
  ['Internal', 'None'],
  ['This is a gift', 'No Gift Message'],
] as const;

export function Notes() {
  return (
    <Accordion title="Notes" defaultExpanded headingLevel={4}>
      <AccordionBodyContainer>
        {NOTES.map(([label, value]) => (
          <div key={label} className="sk:grid sk:grid-cols-[5fr_7fr] sk:gap-3">
            <div>{label}</div>
            <BoldText>{value}</BoldText>
          </div>
        ))}
      </AccordionBodyContainer>
    </Accordion>
  );
}
